import { Locale } from '../enums/locale';
const localeMap = {
    [Locale.RO]: 'Europe/Bucharest'
};
export const getTimezoneByLocale = (locale) => localeMap[locale];
